<lib-service-policy-form #servicePolicyForm>
  @if (showConflictBanner) {
    <div slot="column-2-slot-1" class="service-policy-extension-container">
      <lib-form-field-container [showHeader]="false">
        <div
          class="conflict-container"
          [matTooltip]="getConflictTooltip()"
          matTooltipShowDelay="150"
          [class.clickable]="!attributeConflictWarning?.resolvesExistingConflict"
          [class.resolved]="attributeConflictWarning?.resolvesExistingConflict"
          (click)="openConflictDetailsModal($event)"
        >
          <div class="conflict-content">
            <div class="conflict-main-row">
              <div class="conflict-icon icon-Network-Failure"></div>
              <span>{{ conflictBannerMessage }}</span>
            </div>
            @if (!attributeConflictWarning?.resolvesExistingConflict) {
              <button
                type="button"
                class="conflict-more-info-link"
                (click)="openConflictDetailsModal($event)"
              >
                Click for details...
              </button>
            }
          </div>
        </div>
      </lib-form-field-container>
    </div>
  }
</lib-service-policy-form>
